import { render, staticRenderFns } from "./evidence_block.vue.js?vue&type=template&id=bf4839f4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./evidence_block.vue?vue&type=template&id=bf4839f4&vue3"
import script from "./evidence_block.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./evidence_block.vue?vue&type=script&lang=js&vue3"
export * from "./evidence_block.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./evidence_block.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports